module.exports = __webpack_public_path__ + "static/appstore-ab473b321f32e296599047d8b71800c4.png";